import React, { useEffect, useState } from "react";
import styles from "./FeaturedProperties.module.scss";
import CardByArea from "./CardByArea/CardByArea";
import { useCountByMultipleQueries } from "../../Hooks/FetchHook";
import { ubications } from "../../utils/constants";

export const FeaturedProperties = () => {
  const queryResults = useCountByMultipleQueries(
    "propiedad",
    Object.values(ubications).map((location) => {
      return [{ fieldPath: "ciudad", opStr: "==", value: location }];
    })
  );
  const [featuresPropertiesCount, setFeaturesPropertiesCount] = useState<any[]>(
    []
  );

  const isLoading = queryResults.some((result) => result.isLoading);

  useEffect(() => {
    !isLoading &&
      featuresPropertiesCount.length === 0 &&
      setFeaturesPropertiesCount(queryResults.map((result) => result.data));
  }, [isLoading]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Propiedades por ubicación</h2>
      <p className={styles.subtitle}>
        ¡Encuentra las mejores propiedades disponibles en tu zona!
      </p>
      <div className={styles.propertiesContainer}>
        {featuresPropertiesCount.map((property, idx) => {
          return (
            <CardByArea
              key={idx}
              location={property?.filter || ""}
              numOfListings={property?.count || 0}
            />
          );
        })}
      </div>
    </div>
  );
};
